import { useState } from 'react';
import { useEffectOnce } from 'react-use';
import { logError } from 'commons/logger';
import getEnvValue from '@/joystagram-components/commons/getEnvValue';
const useRudderStackAnalytics = () => {
  const [analytics, setAnalytics] = useState();
  useEffectOnce(() => {
    if (!analytics) {
      const initialize = async () => {
        const {
          RudderAnalytics
        } = await import('@rudderstack/analytics-js');
        const analyticsInstance = new RudderAnalytics();
        analyticsInstance.load(getEnvValue('NEXT_PUBLIC_RUDDER_STACK_WRITE_KEY'), getEnvValue('NEXT_PUBLIC_RUDDER_STACK_DATA_PLANE_URL'));
        setAnalytics(analyticsInstance);
      };
      initialize().catch(e => logError(e, 'Error initializing RudderAnalytics instance'));
    }
  });
  return analytics;
};
export default useRudderStackAnalytics;